import React from 'react';
import DownArrow from '../components/downArrow';

export default class HomeSix extends React.Component {

	render(){
		return (

		   	<div id="home_six" className="home_second home_six hide_overflow">
		   		<div className="container h-100per">
		   			<div className="row h-100per">
		   				<div className="col-sm-6 full-height-col-sm h-50per-xs">

		   					<div className="outer-center">
		   						<div className="middle-center">
		   							<div className="inner-center home_sixth_content">
		   								<h1>Tipigo allows you to manage a dynamic portfolio enhanced with selected stocks </h1>
		   								<div className="green_line"></div>
		   								<p>

		   									<br/>Investing in selected stocks allows you to achieve superior returns, as opposed to managing static, ETF-based portfolios.
		   									<br/>There are always lucrative opportunities ready to be expolited.
		   									<br/>Use Tipigo's custom Auto Research Platform (ARP) to find them in time and act swiftly.

		   									{/*}
		   									We believe that an ever-changing market calls for a dynamic investment strategy.
		   									 <br/>
		   									Our portfolios undergo frequent changes, at times daily, in order to adapt to varying market conditions.
		   									*/}
		   								</p>
		   								</div>
		   							</div>
		   						</div>
		   					</div>
		   				<div className="col-sm-6 full-height-col-sm h-50per-xs">

		   					 <img className="home_second_img" alt="dynamic" src={require("../../img/dynamic1.jpg")}/>
		   				</div>
		   			</div>
		   		</div>
		   		{/*<DownArrow elementId="home_six"></DownArrow>  */}

		       </div>
		);
	}

}


	// <div className="home_six hide_overflow">
	// 	<div className="container">
	// 		<div className="row">
	// 			<div className="col-sm-12 home_six_contant_height">

	// 				<div className="outer-center">
	// 					<div className="middle-center">
	// 						<div className="inner-center">
	// 							<div className="home_six_paragraph text-center">
	// 								<h3>Dynamic portfolio</h3>
	// 								<div className="green_line"></div>
	// 								<p>
	// 								Tipigo allows you to manage a dynamic portfolio enhanced with selected stocks. Investing in selected stocks allows you to achieve superior returns, as opposed to managing static, ETF-based portfolios. There are always lucrative opportunities ready to be expolited. Use Tipigo's custom Auto Research Platform (ARP) to find them in time and act swiftly.
	// 								</p>
	// 							</div>
	// 						</div>
	// 					</div>
	// 				</div>

	// 			</div>

	// 			<div className="col-sm-4 home_six_contant_height">

	// 				<div className="outer-center">
	// 					<div className="middle-center">
	// 						<div className="inner-center">
	// 							<div className="home_six_paragraph">
	// 								<h3>Investing has evolved</h3>
	// 								<div className="green_line"></div>
	// 								<p>Test drive our self-driving investment vehicle that’s faster, smarter and comes with a cool dashboard. Finally you can witness the winning performance of a tailored portfolio in live action.</p>
	// 							</div>
	// 						</div>
	// 					</div>
	// 				</div>
	// 			</div>

	// 			<div className="col-sm-4 home_six_contant_height">

	// 				<div className="outer-center">
	// 					<div className="middle-center">
	// 						<div className="inner-center">
	// 							<div className="home_six_paragraph">
	// 								<h3>Audited & evidence-based</h3>
	// 								<div className="green_line"></div>
	// 								<p>Our winning portfolios are fully trasparent and audited by leading accounting firms. Time after time, they have suc- cessfully outperformed the market, without leverage or taking unnecessary risk.</p>
	// 							</div>
	// 						</div>
	// 					</div>
	// 				</div>

	// 			</div>
	// 		</div>

	// 	</div>
 //    </div>



// WEBPACK FOOTER //
// ./src/js/components/HomeSix.js